/*
 * Copyright (C) 2021 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { Collapse, styled, Typography } from '@material-ui/core';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import React, { useEffect, useState } from 'react';

import { Overflow } from '../Overflow';
import { Actionable } from 'components/UI';

const Wrapper = styled(Overflow)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  padding: theme.spacing(4),
  textAlign: 'center',
}));

const LinkWrapper = styled(Actionable)(({ theme }) => ({
  color: theme.palette.common.white,
}));

const Banners: React.FC = () => {
  const [envState, setEnvState] = useState({ browser: false, cabin: false });
  const hotelBannerEnabled = useFeatureFlagEnabled('hotel-announcement-banner');

  useEffect(() => {
    const inBrowser = typeof window !== 'undefined';
    setEnvState({
      browser: inBrowser,
      cabin: inBrowser && (window as any).AFHostAppName === 'cabin',
    });
  }, [setEnvState]);

  return (
    <>
      <Collapse in={hotelBannerEnabled && envState.browser && !envState.cabin}>
        <Wrapper>
          <Typography variant="body2">
            NEW: Book your hotel with Airfordable! 🏨{' '}
            <LinkWrapper to="/download">Download our app </LinkWrapper>
            to get started now.
          </Typography>
        </Wrapper>
      </Collapse>
      {/* <Collapse in={envState.browser && !envState.cabin}>
        <Wrapper>
          <Typography variant="body2">
            ✨ We are hiring 🔥. Check out open positions{' '}
            <LinkWrapper to="/careers">here</LinkWrapper>
          </Typography>
        </Wrapper>
      </Collapse> */}
    </>
  );
};

export { Banners };
